import { render, staticRenderFns } from "./OracleCloud.vue?vue&type=template&id=bfa53a0c"
import script from "./OracleCloud.vue?vue&type=script&lang=js"
export * from "./OracleCloud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports